import { createContext, useContext } from "react";
export const PortalRootContext = createContext(
/* istanbul ignore next (SSR Accommodation) */
typeof document !== "undefined" && document !== null ? document.body : null);
export const usePortalRoot = () => useContext(PortalRootContext);
